/// <reference types="mocha" />

import { assert } from 'chai';

describe('BannerWpWebPart', () => {
  it('should do something', () => {
    assert.ok(true);
  });
});
